import { createSelector } from "reselect";
import { isPccSelector } from "src/selectors/config_selectors";
export const showLockWoundRevisionButtonSelector = createSelector(
  isPccSelector,
  isPcc => {
    return !isPcc;
  }
);
